import { Children } from 'react';
import { TrackingEvent } from '../../../Services/Tracking/TrackingService';
import TableSkeleton from '../../Layout/TableSkeleton';
import { ApiListResponse } from './ApiListResponse';
import Pagination from './Pagination';
import styles from './TableWrapper.module.scss';

interface IPaginationTableWrapperProps {
    children: JSX.Element;
    apiListResponse?: ApiListResponse;
    showPagination?: boolean;
    handlePagination?: (apiListResponse: ApiListResponse) => void;
    handleTakeCountUpdate?: (apiListResponse: ApiListResponse) => void;
    track: TrackingEvent;
}

const PaginationTableWrapper = (props: IPaginationTableWrapperProps) => (
    <div className={styles.companies}>
        {!props.apiListResponse || props.apiListResponse.totalCount === undefined ? (
            <TableSkeleton />
        ) : (
            <div>
                {Children.only(props.children!)}
                <div>
                    {props.showPagination && (
                        <Pagination
                            apiListResponse={props.apiListResponse}
                            handlePagination={props.handlePagination}
                            handleTakeCountUpdate={props.handleTakeCountUpdate}
                            track={props.track}
                        />
                    )}
                </div>
            </div>
        )}
    </div>
);

export default PaginationTableWrapper;
